<template>
  <v-container class="mt-5" fluid>
    <v-row>
      <v-col offset-md="1" md="10">
        <v-row>
          <v-col cols="12" lg="3" md="4">
            <v-card elevation="0" color="accent" :min-height="windowInnerHeight-250" :max-height="windowInnerHeight-250" class="overflow-auto">
              <v-card-title>{{ $t("views.messages.title.messages") }}</v-card-title>
              <v-card-text jus>
                <v-progress-circular :size="50" indeterminate color="primary" v-if="messageDataOrderEvents == null" ></v-progress-circular>
                <v-list v-else>
                  <v-list-item v-if="messageDataOrderEvents.length == 0">
                    <v-list-item-content>
                      <v-list-item-title>{{ $t("views.messages.messageList.noEntries") }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-for="messageOrderEvent in filterOrderEvents()" :key="messageOrderEvent.Id" @click="messageOrderEventIdSelected = messageOrderEvent.Id">
                    <v-list-item-content>
                      <v-list-item-title>{{ messageOrderEvent.Type }}</v-list-item-title>
                      <v-list-item-subtitle>{{ messageOrderEvent.DisplayName }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" lg="9" md="8">
            <v-card elevation="1" :min-height="windowInnerHeight-250" :max-height="windowInnerHeight-250">
              <v-card elevation="0">
                <v-card-title>{{ messageOrderEventIdSelected ? messageDataOrderEvents.filter(x => x.Id == messageOrderEventIdSelected)[0].Type : 'Chat' }}</v-card-title>
                <v-card-subtitle v-if="messageOrderEventIdSelected">{{ messageDataOrderEvents.filter(x => x.Id == messageOrderEventIdSelected)[0].DisplayName }}</v-card-subtitle>
              </v-card>
              <v-card elevation="0" v-if="!messageOrderEventIdSelected">
                <v-card-text>
                  <div >
                    <span><i>{{ $t("views.messages.messageList.selectChatOnTheLeftSide") }}</i></span>
                  </div>
                </v-card-text>
              </v-card>
              <v-card elevation="0" :min-height="windowInnerHeight-550" :max-height="windowInnerHeight-550" class="overflow-y-auto" v-chat-scroll="{enabled: true, always: false, smooth: true, notsmoothoninit: true}" v-else>
                <div
                  v-for="message in messageData.filter(x => x.OrderEventId == messageOrderEventIdSelected)"
                  :key="message.Id"
                  :class="{ 'd-flex flex-row-reverse': message.IsSenderExternal }"
                >
                  <v-card elevation-0 :class="['ma-2'].concat(message.IsSenderExternal == true ? ['grey', 'lighten-4'] : ['light-green', 'lighten-4'])" max-width="45%" >
                    <v-col>
                      <v-row dense>
                        <v-col style="font-size: 1.2em;"><b>{{ message.Sender }}</b></v-col>
                      </v-row>
                      <v-row dense>
                        <v-col><div v-html="message.Content"></div></v-col>
                      </v-row>
                      <v-row dense>
                        <v-col class="text-right" style="font-size: 0.8em;"><i>{{ $d(Date.parse(message.Created), 'long') }}</i></v-col>
                      </v-row>
                      <v-row dense v-if="message.Attachments.length > 0">
                        <v-col>
                          <v-divider></v-divider>
                          <v-list dense :class="message.IsSenderExternal == true ? ['grey', 'lighten-4'] : ['light-green', 'lighten-4']">
                            <v-list-item v-for="attachment of message.Attachments" v-bind:key="attachment.Id" @click="downloadAttachment(message.Id, attachment.Id)">
                              <v-list-item-icon><v-icon>mdi-paperclip</v-icon></v-list-item-icon>
                              <v-list-item-content>{{ attachment.FileName }}</v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </div>
              </v-card>
              <v-card elevation="0" v-if="messageOrderEventIdSelected">
                <v-card-text>
                  <v-text-field v-model="msg" outlined :placeholder="$t('views.messages.messageList.messageInput')" :label="$t('views.messages.messageList.message')" @keypress.enter="send">
                    <v-icon slot="prepend">mdi-pencil</v-icon>
                  </v-text-field>
                  <v-file-input
                    accept="image/*"
                    multiple
                    chips
                    counter
                    small-chips
                    truncate-length="15"
                    outlined
                    :placeholder="$t('views.messages.messageList.fileInput')"
                    :label="$t('views.messages.messageList.attachments')"
                    @change="fileSelectionChanged($event)"
                  ></v-file-input>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="send">{{ $t("views.messages.messageList.send") }}<v-icon class="ml-2">mdi-send</v-icon></v-btn>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiClient from '../plugins/CustomerPortalApiClient/client';
import {saveAs} from 'file-saver';

export default {
  name: "Messages",
  data() {
    return {
      messageData: [],
      messageDataOrderEvents: null,
      messageOrderEventIdSelected: null,
      msg: null,
      messageAttachments: [],
      windowInnerHeight: window.innerHeight
    }
  },
  methods: {
    filterOrderEvents: function () {
      let result = [];
      this.messageDataOrderEvents.forEach(function(item) {
        if (result.findIndex(x => x.Id == item.Id) == -1) {
          result.push(item)
        }
      });
      return result;
    },
    loadLisaMessages: function () {
      apiClient
        .loadLisaMessages(this.$store.getters.token(), this.$store.getters.customerNumber())
        .then((lisaMessages) => {
          this.messageData = lisaMessages;
          this.messageDataOrderEvents = this.messageData.map((val) => { return {Id: val.OrderEventId, State: val.OrderEventSate, DisplayName: val.OrderEventOrderDisplayName, Type: val.OrderEventType }; });
          this.messageDataLoaded = true;
        }).catch((error) => {
          console.error(error);
          this.$snackbar(this.$t("views.messages.errors.loadingMessages"), 'red darken-1');
        });
    },
    downloadAttachment: function (messageId, attachmentId) {
      apiClient.loadLisaMessageAttachment(
        this.$store.getters.getToken(),
        this.$store.getters.customerNumber(),
        messageId,
        attachmentId
      ).then((attachment) => {
        saveAs(
          attachment.Base64Content,
          attachment.FileName,
          'base64'
        );
      }).catch((error) => {
        console.error(error);
        this.$snackbar(this.$t("views.messages.errors.loadingAttachment"), 'red darken-1');
      });
    },
    fileSelectionChanged: function (files) {
      this.messageAttachments = files;
    },
    send: function () {
      apiClient
        .createLisaMessage(this.$store.getters.getToken(), this.messageOrderEventIdSelected, this.msg, this.messageAttachments)
        .then((success) => {
          if (success === true) {
            this.loadLisaMessages();
          }
        }).catch((error) => {
          console.error(error);
          this.$snackbar(this.$t("views.messages.errors.sendMessage"), 'red darken-1');
        });
    },
    onResize: function () {
      this.windowHeight = window.innerHeight;
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  watch: {
  },
  created() {
    this.loadLisaMessages();
  }
};
</script>
